
import { useCallback } from 'react';

export const useArticleMediaHandling = (
  uploadArticleMedia: (file: File) => Promise<string | null>,
  createArticleTag: (name: string) => Promise<any>
) => {
  // Handle header image upload
  const handleHeaderImageUpload = useCallback(async (file: File) => {
    try {
      const url = await uploadArticleMedia(file);
      return url || '';
    } catch (error) {
      console.error('Error uploading header image:', error);
      return '';
    }
  }, [uploadArticleMedia]);

  // Handle creating new tag
  const handleCreateTag = useCallback(async (name: string) => {
    try {
      const newTag = await createArticleTag(name);
      return newTag;
    } catch (error) {
      console.error('Error creating tag:', error);
      return null;
    }
  }, [createArticleTag]);

  return {
    handleHeaderImageUpload,
    handleCreateTag
  };
};
